@defer (hydrate on immediate) {

	<div class="flex flex-col gap-24 pt-20">

		<div class="flex flex-col lg:flex-row gap-8 lg:items-center justify-center">
			<div class="relative w-screen h-auto aspect-[7/8.5] lg:w-[700px] lg:h-[850px] group">
				<div
					class="absolute inset-0 z-0 bg-cover bg-center member-clip-shape-background transition-all scale-[98%] duration-[1500ms] ease-in-out group-hover:scale-105 group-hover:brightness-75 group-hover:-rotate-1 -translate-y-8 -translate-x-8 group-hover:-translate-y-8 group-hover:translate-x-1"
					style="background-image: url('/assets/images/member_details_background.avif')"
				></div>
				<div
					class="bg-[url('/assets/images/fefe_ben_padel.png')] relative z-10 w-full h-full bg-cover bg-center member-clip-shape-foreground transition-all duration-[1500ms] ease-in-out group-hover:scale-105 group-hover:-rotate-1 group-hover:brightness-100"
				></div>
				<svg width="251" height="92" viewBox="0 0 251 92" fill="none" xmlns="http://www.w3.org/2000/svg" class="invisible lg:visible absolute -bottom-5 right-20 z-10 group-hover:-translate-x-40 group-hover:-translate-y-10 transition-transform transform duration-[1500ms]">
					<path d="M191.743 57.8025L0.915671 0.840229L30.0065 16.5841L191.833 60.3166L191.743 57.8025Z" fill="#F9ECEA"/>
					<path d="M245.824 91.9538L250.706 17.1007L217.004 36.7631L227.119 85.0694L245.824 91.9538Z" fill="#F9ECEA"/>
				</svg>
				<svg width="54" height="119" viewBox="0 0 54 119" fill="none" xmlns="http://www.w3.org/2000/svg" class="invisible lg:visible absolute top-65 -left-1 z-10 group-hover:translate-y-35 group-hover:translate-x-10 transition-transform transform duration-[1500ms]">
					<path d="M53.139 84.2419L17.4362 0.767658L0.674113 48.3548L33.3844 118.51L53.139 84.2419Z" fill="#F9ECEA"/>
				</svg>
				<svg width="54" height="216" viewBox="0 0 54 216" fill="none" xmlns="http://www.w3.org/2000/svg" class="invisible lg:visible absolute transition-transform transform duration-[1500ms] right-15 top-28 z-10 group-hover:-translate-y-15">
					<path d="M53.4199 0.785156L41.0523 195.056L21.6573 215.886L25.5517 113.378L0.142752 83.2387L4.81457 2.51935L53.4199 0.785156Z" fill="#F9ECEA"/>
				</svg>

			</div>

			<div class="relative flex flex-col gap-8 px-8 lg:px-0 lg:pr-8 lg:items-start lg:w-1/2 z-20">
				<div class="flex flex-col gap-2 items-start lg:items-center lg:-translate-x-9">
					<div class="flex lg:justify-start">
						<div class="bg-[url(/assets/images/cross.avif)] bg-no-repeat w-32 h-36 flex flex-col justify-center lg:items-start text-peps-dark-200">
							<h1 class="text-9xl z-30 text-left text-nowrap lg:translate-x-8 translate-y-8 uppercase">Padel</h1>
							<h2 class="text-[32px] z-30 text-left text-nowrap lg:translate-x-8 translate-y-4 uppercase">Féfé & Benbest</h2>
						</div>
					</div>
				</div>

				<div class="flex flex-col">
					<span class="uppercase">{{ 'page.member-details.country' | translate }}:
						<span [classList]="'ml-2 fi fi-' + $safeNavigationMigration('fr')"></span>
					</span>
				</div>

				<span class="block whitespace-pre-line font-notosans text-justify w-full lg:w-3/4">
					{{ 'page.roster-sport.padel.description' | translate }}
				</span>

				<div class="flex flex-row gap-4 items-center uppercase">
					<a href="https://www.instagram.com/fefegg_" target="_blank" rel="noopener noreferrer" class="flex items-center gap-2 text-peps-dark-200 hover:text-peps-dark-100 transition-colors duration-300">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path d="M7 2C4.239 2 2 4.239 2 7V17C2 19.761 4.239 22 7 22H17C19.761 22 22 19.761 22 17V7C22 4.239 19.761 2 17 2H7ZM7 4H17C18.654 4 20 5.346 20 7V17C20 18.654 18.654 20 17 20H7C5.346 20 4 18.654 4 17V7C4 5.346 5.346 4 7 4ZM17 5.5C16.448 5.5 16 5.948 16 6.5C16 7.052 16.448 7.5 17 7.5C17.552 7.5 18 7.052 18 6.5C18 5.948 17.552 5.5 17 5.5ZM12 7C9.239 7 7 9.239 7 12C7 14.761 9.239 17 12 17C14.761 17 17 14.761 17 12C17 9.239 14.761 7 12 7ZM12 9C13.657 9 15 10.343 15 12C15 13.657 13.657 15 12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9Z" fill="currentColor"/>
						</svg>
						<span>Féfé</span>
					</a>
					<a href="https://www.instagram.com/benbest_ow" target="_blank" rel="noopener noreferrer" class="flex items-center gap-2 text-peps-dark-200 hover:text-peps-dark-100 transition-colors duration-300">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path d="M7 2C4.239 2 2 4.239 2 7V17C2 19.761 4.239 22 7 22H17C19.761 22 22 19.761 22 17V7C22 4.239 19.761 2 17 2H7ZM7 4H17C18.654 4 20 5.346 20 7V17C20 18.654 18.654 20 17 20H7C5.346 20 4 18.654 4 17V7C4 5.346 5.346 4 7 4ZM17 5.5C16.448 5.5 16 5.948 16 6.5C16 7.052 16.448 7.5 17 7.5C17.552 7.5 18 7.052 18 6.5C18 5.948 17.552 5.5 17 5.5ZM12 7C9.239 7 7 9.239 7 12C7 14.761 9.239 17 12 17C14.761 17 17 14.761 17 12C17 9.239 14.761 7 12 7ZM12 9C13.657 9 15 10.343 15 12C15 13.657 13.657 15 12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9Z" fill="currentColor"/>
						</svg>
						<span>Benbest</span>
					</a>

				</div>


				<div class="flex flex-col gap-2 items-start ">
					<div class="flex flex-col md:flex-row justify-around items-center gap-4 lg:-translate-x-9">
						<h1 class="text-4xl sm:text-8xl z-30 text-left text-nowrap lg:translate-x-8 uppercase">{{ 'page.roster-sport.padel.title' | translate }}</h1>
					</div>

					<div class="flex flex-row items-center justify-around lg:justify-between text-xl w-full uppercase">
						<span>Féfé = </span>
						<span>Benbest = </span>
					</div>

				</div>

			</div>

		</div>

		<peps-last-videos></peps-last-videos>

	</div>
}
